const doc = [({"en":({"labelTop":({"company":"Company name", "email":"Email", "firstname":"First name", "lastname":"Last name", "phone":"Phone"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;